import { AccountOuput } from '@allocab/allocab-passenger-shared-types';
import { useQuery } from '@tanstack/react-query';
import type { UseQueryOptions } from '@tanstack/react-query';

import { queryKeys } from '../services/datastore/queryKeys';
import { DEFAULT_CACHE_TIME, queryErrorHandler, silentQueryErrorHandler } from '../services/datastore/react-query';
import { passengerApi } from '../services/network/Api';

const fetchAccount = () => passengerApi.get<void, AccountOuput>('/account/v1/me');

export const useFetchAccount = (
  options: Omit<UseQueryOptions<AccountOuput, unknown, AccountOuput, string[]>, 'queryKey' | 'queryFn'> = {},
  silent = true,
) =>
  useQuery(queryKeys.user.account(), fetchAccount, {
    staleTime: DEFAULT_CACHE_TIME,
    cacheTime: DEFAULT_CACHE_TIME,
    onError: silent ? silentQueryErrorHandler : queryErrorHandler,
    ...options,
  });
